import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	logoImg: {
		maxHeight: 70,
		width: "200px"
	},
	authPluginStatus: {
		backgroundColor: colors.green[500],
		color: colors.gray[0]
	},
	unAuthPluginStatus: {
		backgroundColor: colors.gray[200],
		color: colors.gray[700]
	},
	authPluginButton: {
		backgroundColor: colors.red[500],
		color: colors.gray[0],
		"&:hover": {
			backgroundColor: colors.red[600]
		}
	}
}))

export default useStyles
